import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Button,
  Offcanvas,
  Form,
  Container,
  Table,
  NavDropdown,
  Dropdown,
  Row,
  Col,
  TablePagination,
  Pagination,
  Modal,
  Badge,
} from "react-bootstrap";
import "../style/admin.css";
import { Typography, ButtonGroup, Box } from "@mui/material";
import { FaDownload, FaFilter, FaPencilAlt } from "react-icons/fa";
import { RxHamburgerMenu } from "react-icons/rx";
import axios from "axios";
import { apibasePath } from "../config";
import Moment from "react-moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../style/layout.css";
import "../style/admin.css";
import { DelOrderItem, EditOrderItem } from "../APICalls";
import toast from "react-hot-toast";
import { FiEdit } from "react-icons/fi";
const OrderFormPrint = () => {
  const [logo, setLogo] = useState(null);
  const [brandLogo, setBrandLogo] = useState(null);
  const [name, setName] = useState(" ");
  const [show, setShow] = useState(false);
  const [allData, setAllData] = useState([]); // All data from API
  const [filteredData, setFilteredData] = useState([]); // Filtered data to show in table
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedOrderNumber, setSelectedOrderNumber] = useState("");
  const [availableCustomers, setAvailableCustomers] = useState([]);
  const [customerMap, setCustomerMap] = useState({});
  const [ordersByCustomer, setOrdersByCustomer] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [pdf, setPdf] = useState([]);
  const [pagecount, setpageCount] = useState(1);
  const [totalPagescount, setTotalPagesCount] = useState();
  const [loading, setLoading] = useState(false);

  const [modalShow, setModalShow] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const Api_url = "https://broker.accountiez.com/client/profiles/company/";
  const Api = "https://broker.accountiez.com/client/profiles/brand/";
  const Token = localStorage.getItem("token");

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(Api_url, {
          headers: { "Content-Type": "application/json" },
        });
        setLogo(response.data.logo);
        setName(response.data.name);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };
    fetchLogo();
  }, []);

  // brand logo
  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);

  // Fetch all data

  const fetchAllData = async () => {
    try {
      const response = await axios.get(
        `${apibasePath}/order/order-items-list/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${Token}`,
          },
        }
      );

      console.log("API response:", response);
      const results = response?.data?.results || [];

      // Create maps for customers and orders
      const customerMap = {};
      const orderMap = {};

      results.forEach((item) => {
        const customerName = item.customer;
        const customerId = item.order.customer;
        const orderNumber = item.order.order_number;

        if (!customerMap[customerName]) {
          customerMap[customerName] = customerId;
          orderMap[customerName] = new Set();
        }

        orderMap[customerName].add(orderNumber);
      });

      // Convert Sets to arrays for dropdowns
      const ordersByCustomer = {};
      for (const customerName in orderMap) {
        ordersByCustomer[customerName] = Array.from(orderMap[customerName]);
      }

      // Set total page count from API count

      setCustomerMap(customerMap);
      setOrdersByCustomer(ordersByCustomer);
      setAvailableCustomers(Object.keys(customerMap));
      setAllData(results);
      setFilteredData(results); // initial display
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  // Fetch filtered data
  const params = new URLSearchParams();

  const customerId = customerMap[selectedCustomer];

  if (selectedCustomer && customerId) {
    params.append("customer_id", customerId);
  }

  if (selectedOrderNumber) params.append("order_number", selectedOrderNumber);
  if (fromDate) params.append("from_date", fromDate);
  if (toDate) params.append("to_date", toDate);
  if (pagecount) params.append("page", pagecount);

  const fetchFilteredData = async () => {
    const url = `${apibasePath}/order/order-items-list/?${params.toString()}`;
    console.log("Fetching with URL:", url);

    try {
      const res = await axios.get(url, {
        headers: { "Content-Type": "application/json" },
      });

      const data = res?.data?.results || [];
      console.log("Filtered API response:", data);
      setFilteredData(data);
      const totalCount = res.data.count || 0;
      console.log("Total Count:", totalCount);

      const totalPages = Math.ceil(totalCount / 10);
      console.log("totalPages", totalPages);

      // Set state
      setTotalPagesCount(totalPages);
    } catch (error) {
      console.error("Failed to fetch filtered data", error);
    }
  };

  // useEffect(() => {
  //   // fetchFilteredData();
  // }, [selectedCustomer, selectedOrderNumber, fromDate, toDate, pagecount]);

  const clearFilters  =() => {
    setSelectedCustomer('');
    setSelectedOrderNumber('');
    setFromDate('');
    setToDate('');
    fetchAllData();
    
  }

  const handleNext = async () => {
    if (pagecount < totalPagescount) {
      const nextPage = pagecount + 1;
      setLoading(true);

      try {
        await fetchFilteredData(nextPage); // Pass next page to API
        setpageCount(nextPage); // Update page after fetch
      } catch (error) {
        console.error("Error fetching next page:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handlePrevious = () => {
    if (pagecount > 1) {
      setpageCount((prevPage) => prevPage - 1);
    }
  };

  // Search by order number
  const handleDirectOrderSearch = (value) => {
    setSelectedOrderNumber(value);
    setpageCount(1);
    if (!value) {
      // If no order number is entered, show all data for selected customer or all data
      if (selectedCustomer) {
        const customerData = allData.filter(
          (item) => item.customer === selectedCustomer
        );
        setFilteredData(customerData);
      } else {
        setFilteredData(allData);
      }
      return;
    }

    // Show specific order number if entered
    const orderData = allData.filter(
      (item) => item.order.order_number === Number(value)
    );
    setFilteredData(orderData);
  };

  const handlePDF = async (item) => {
    try {
      const responses = await axios.get(
        `${apibasePath}/order/order-items-list/?download=true&${params.toString()}`,
        {
          headers: {
            Authorization: `bearer ${Token}`, // Capitalized "Bearer"
            "Content-Type": "application/json",
          },
          responseType: "blob", // if you're expecting a file like a PDF
        }
      );

      console.log("PDF Response:", responses.data);

      // If you're setting the PDF blob in state to view/download
      setPdf(responses.data);

      // Optional: If you want to trigger download
      const url = window.URL.createObjectURL(new Blob([responses.data]));
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "order-summary.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  // download excel

  const fetchAllPagesData = async () => {
    const pageSize = 10; // or your actual page size
    let currentPage = 1;
    let allData = [];
    let totalFetched = 0;

    while (true) {
      const params = new URLSearchParams();

      const customerId = customerMap[selectedCustomer];
      if (selectedCustomer && customerId) {
        params.append("customer_id", customerId);
      }
      if (selectedOrderNumber)
        params.append("order_number", selectedOrderNumber);
      if (fromDate) params.append("from_date", fromDate);
      if (toDate) params.append("to_date", toDate);
      params.append("page", currentPage);

      const response = await fetch(
        `${apibasePath}/order/order-items-list/?${params.toString()}`
      );
      const result = await response.json();

      if (result?.results?.length === 0) break;

      allData = [...allData, ...result.results];
      totalFetched += result.results.length;

      // Stop if less than pageSize => last page
      if (result.results.length < pageSize) break;

      currentPage++;
    }

    return allData;
  };

  const exportToExcel = async () => {
    const allData = await fetchAllPagesData();

    const exportData = allData.map((item, index) => ({
      "S.No": index + 1,
      "Order No": item?.order?.order_number,
      "Order Date": item?.order?.order_date,
      Customer: item?.customer,
      "Item No": item?.stock?.item_code,
      Tag: item?.stock?.tag,
      "Item Name": item?.stock?.item_tag,
      Purity: item?.stock?.purity,
      Quantity: item?.order_quantity,
      Comments: item?.remarks,
      "Gr Wt": item?.stock?.gross_weight,
      "Tr Wt": item?.stock?.stone_weight,
      "Net Wt": item?.stock?.net_weight,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OrderData");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, "OrderData.xlsx");
  };

  const [showEditModal, setShowEditModal] = useState([]);


  return (
    <>
      {/* Top Navbar */}

      {/* <Navbar bg="light" variant="dark" expand="lg" className="px-3 fixed-top">
        <Container fluid>
          <Navbar.Brand className="ms-2">
            <div className="logo-container">
              {logo && <img src={logo} alt="Company Logo" />}
            </div>
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {name}
          </Navbar.Brand>

          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "25px",
            }}
          >
            {" "}
            ORDER FORM PRINT
          </Navbar.Brand>
          <Button
            variant="outline-light"
            className="d-lg-none"
            onClick={handleShow}
          >
            <RxHamburgerMenu
              style={{
                width: "30px",
                height: "30px",
                cursor: "pointer",
                color: "#000",
              }}
            />
          </Button>
        </Container>
      </Navbar> */}

      {/* Main Content */}
      <div className="main-content h-80">
        <main className="content">
          <div className="header-section">
            {/* page Data */}
            <Row
              className="align-items-end gx-4 gy-3"
              style={{ width: "100%" }}
            >
              <Col
                xs={12}
                md={5}
                lg={4}
                style={{ flex: "0 0 35%" }}
                className=""
              >
                <div className="d-flex flex-column gap-3">
                  {/* Customer Name */}
                  <div className="d-flex align-items-center">
                    <Form.Label
                      className="m-0"
                      style={{
                        minWidth: "144px",
                        color: "#226963",
                        fontFamily: "Roboto",
                        fontWeight: "600",
                        fontSize: "18px",
                      }}
                    >
                      Customer name:
                    </Form.Label>
                    <Form.Select
                      value={selectedCustomer}
                      onChange={(e) => {
                        const newCustomer = e.target.value;
                        setSelectedCustomer(newCustomer);
                        setpageCount(1);
                        setSelectedOrderNumber(""); // 👈 Clear order number
                      }}
                    >
                      <option value="">Select Customer</option>
                      {availableCustomers.map((cust) => (
                        <option key={cust} value={cust}>
                          {cust}
                        </option>
                      ))}
                    </Form.Select>
                  </div>

                  {/* Order No */}
                  <div className="d-flex align-items-center">
                    <Form.Label
                      className="m-0"
                      style={{
                        minWidth: "100px",
                        color: "#226963",
                        fontFamily: "Roboto",
                        fontWeight: "600",
                        fontSize: "18px",
                      }}
                    >
                      Order no:
                    </Form.Label>
                    <div className="d-flex align-items-center">
                      {selectedCustomer ? (
                        <Form.Select
                          value={selectedOrderNumber}
                          onChange={(e) => {
                            const newOrderNumber = e.target.value;
                            setSelectedOrderNumber(newOrderNumber);
                            setpageCount(1);
                          }}
                          disabled={!selectedCustomer} // Disable until customer selected
                        >
                          <option value="">Select Order Number</option>
                          {(ordersByCustomer[selectedCustomer] || []).map(
                            (orderNum) => (
                              <option key={orderNum} value={orderNum}>
                                {orderNum}
                              </option>
                            )
                          )}
                        </Form.Select>
                      ) : (
                        <input
                          style={{
                            borderColor: "#226963",
                            borderRadius: "5px",
                            width: "150px",
                          }}
                          type="number"
                          placeholder="Enter Order No"
                          onChange={(e) =>
                            handleDirectOrderSearch(e.target.value)
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              </Col>

              <Col
                xs={12}
                md={7}
                lg={8}
                style={{ flex: "0 0 60%" }}
                className=""
              >
                <Row className="gx-3 gy-3 align-items-end justify-content-end">
                  {/* From Date */}
                  <Col xs={12} sm={6} md={4}>
                    <Form.Label
                      style={{
                        color: "#226963",
                        fontFamily: "Roboto",
                        fontWeight: "600",
                        fontSize: "18px",
                        width: "97px",
                      }}
                    >
                      From Date:
                    </Form.Label>
                    <input
                      value={fromDate}
                      onChange={(e) => {
                        const newFromDate = e.target.value;
                        setFromDate(newFromDate);
                        setpageCount(1);
                      }}
                      type="date"
                      style={{
                        borderColor: "#226963",
                        borderRadius: "5px",
                      }}
                    />
                  </Col>

                  {/* To Date */}
                  <Col xs={12} sm={6} md={4}>
                    <Form.Label
                      style={{
                        color: "#226963",
                        fontFamily: "Roboto",
                        fontWeight: "600",
                        fontSize: "18px",
                        width: "73px",
                      }}
                    >
                      To Date:
                    </Form.Label>
                    <input
                      type="date"
                      value={toDate}
                      onChange={(e) => {
                        const newToDate = e.target.value;
                        setToDate(newToDate);
                        setpageCount(1);
                      }}
                      style={{
                        borderColor: "#226963",
                        borderRadius: "5px",
                      }}
                    />
                  </Col>

                  {/* Download Dropdown */}
                  <Col xs={6} sm={6} md={2}>
                    <Dropdown className="w-100">
                      <Dropdown.Toggle
                        className="w-100 "
                        style={{ backgroundColor: "#226963" }}
                      >
                        <FaDownload />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={handlePDF}>
                          Download PDF
                        </Dropdown.Item>
                        <Dropdown.Item onClick={exportToExcel}>
                          Download Excel
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>

                  {/* Filter Button */}
                  {/* <Col xs={6} sm={6} md={2}>
                  <Button variant="outline-secondary" className="w-100 rounded">
                    <div className="d-flex justify-content-between align-items-center">
                      <strong
                        style={{
                          color: "#226963",
                          fontFamily: "Roboto",
                          fontWeight: "600",
                          fontSize: "16px",
                        }}
                      >
                        Filter
                      </strong>
                      <FaFilter />
                    </div>
                  </Button>
                </Col> */}
                </Row>

                <Row className=" mt-4 ">
                    <div className="d-flex justify-content-end gap-3" >
                    <Button onClick={clearFilters}  variant="outline-secondary" style={{width:'max-content'}} > Clear Filters </Button>
                    <Button onClick={fetchFilteredData} variant="success" style={{width:'max-content', background:'rgb(34, 105, 99)'}} > Submit Filters</Button>

                    </div>
              
                  <Col>
                  </Col>
                  <Col>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {/* Table */}

          <Table className="table mt-3" responsive striped bordered hover>
            <thead>
              <tr style={{ color: "#35646E", borderBottom: "1px solid black" }}>
                {[
                  "S.No",
                  "Order No",
                  "Image",
                  "Order Dt",
                  "Item No",
                  "Tag",
                  "Item Name",
                  "Purity",
                  "Quantity",
                  "Comments",
                  "Gr Wt",
                  "Tr Wt",
                  "Net Wt",
                  "Stock Status",
                  "Actions",
                ].map((header, idx) => (
                  <th
                    key={idx}
                    style={{
                      backgroundColor: "#C5CACF",
                      color: "#35646E",
                      fontFamily: "Roboto",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.order.order_number}</td>
                  <td>
                    <img
                      style={{
                        height: "60px",
                        width: "60px",
                      }}
                      src={item.stock.image}
                      alt={item.stock.item_tag}
                    />
                  </td>
                  <td>
                    <Moment format="DD-MM-YYYY">{item.order.order_date}</Moment>
                  </td>
                  <td>{item.stock.item_code}</td>
                  <td>{item.stock.tag}</td>
                  <td>{item.stock.item_tag}</td>
                  <td>{item.stock.purity}</td>
                  <td>
                    {item.order_quantity}{" "}
                    <FiEdit
                      onClick={() =>
                        setShowEditModal([
                          item?.id,
                          "order_quantity",
                          item?.order_quantity,
                        ])
                      }
                    />{" "}
                  </td>
                  <td>
                    <div className="d-flex justify-content-between">
                      {item.remarks || "--"}{" "}
                      <FiEdit
                        className="fle"
                        fontSize={15}
                        onClick={() =>
                          setShowEditModal([item?.id, "remarks", item?.remarks])
                        }
                      />
                    </div>
                  </td>
                  <td>{item.stock.gross_weight}</td>
                  <td>{item.stock.stone_weight}</td>
                  <td>{item.stock.net_weight}</td>
                  <td>
                    <Badge
                      pill
                      bg="rgb(53, 100, 110)"
                      style={{
                        backgroundColor: item.order_status
                          ? "rgb(46, 97, 108)"
                          : "rgb(23, 134, 75)",
                      }}
                    >
                      {item.order_status ? "Order" : "Stock"}
                    </Badge>
                    {/* <span style={{ margin:'auto 0' , border:'2px solid rgb(53, 100, 110)', color:'rgb(53, 100, 110)', fontSize:'13px' }} className="   rounded-pill p-1" > {item.stock.order_status ? "Order":'Stock'} </span> */}
                  </td>
                  <td>
                    {" "}
                    <Button
                      variant="outline-danger"
                      onClick={() => {
                        setModalShow(item.id);
                      }}
                      style={{ color: "" }}
                      color="#226963"
                    >
                      {" "}
                      Delete{" "}
                    </Button>{" "}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Box sx={{ mr: 5 }}>
            <Box
              mt={2}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <ButtonGroup>
                <Button
                  style={{ backgroundColor: "#226963" }}
                  onClick={handlePrevious}
                  sx={{ border: "1px solid", mr: 1 }}
                  disabled={pagecount === 1}
                >
                  Previous
                </Button>
                <Typography sx={{ px: 2, my: 1, color: "#850101" }}>
                  Page {pagecount}
                </Typography>
                <Button
                  style={{ backgroundColor: loading ||
                    pagecount >= totalPagescount ||
                    totalPagescount === 0 ? "#226963" : '#7ab1ac',
                    borderColor: loading ||
                    pagecount >= totalPagescount ||
                    totalPagescount === 0 ? "#226963" : '#7ab1ac',
                      }}
                  onClick={handleNext}
                  sx={{ border: "1px solid" }}
                  disabled={
                    loading ||
                    pagecount >= totalPagescount ||
                    totalPagescount === 0
                  }
                >
                  {loading ? "Loading..." : "Next"}
                </Button>
              </ButtonGroup>
            </Box>
          </Box>

          {/* brand logo */}
        </main>
      </div>
      <GetModal
        delId={modalShow}
        show={modalShow != null}
        onHide={() => setModalShow(null)}
        setFilteredData={setFilteredData}
      />
      <EditModal
        editDetails={showEditModal}
        show={showEditModal.length > 0}
        onHide={() => setShowEditModal([])}
        setFilteredData={setFilteredData}
      />
    </>
  );
};

export default OrderFormPrint;

function GetModal(props) {
  const handleDelOrderItem = async () => {
    const data = await DelOrderItem(props.delId);

    if (data) {
      toast.success("Order Deleted Successfully");
      props.setFilteredData((prev) =>
        prev.filter((item) => item.id !== props.delId)
      );
      props.onHide();
    } else {
      toast.error("Failed to Delete Order Item");
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ border: "none" }} closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {" "}
          Are You Sure ?
        </Modal.Title>
      </Modal.Header>

      <Modal.Footer style={{ border: "none" }}>
        <Button variant="outline-secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button variant="outline-danger" onClick={handleDelOrderItem}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function EditModal(props) {
  const editId = props.editDetails[0];
  const fieldName = props.editDetails[1];
  const [val, setVal] = useState();

  useEffect(() => {
    setVal(props.editDetails[2]);
  }, [props]);

  const handleEditField = async () => {
    const data = await EditOrderItem(editId, { [fieldName]: val });

    if (!data.error) {
      toast.success("Order Edited Successfully");
      props.setFilteredData((prev) =>
        prev.map((item) =>
          item.id === editId ? { ...item, [fieldName]: val } : item
        )
      );

      props.onHide();
    } else {
      toast.error("Failed to Delete Order Item");
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header style={{ border: "none" }} closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {" "}
          Edit {fieldName =='remarks' ? 'Comments' : fieldName =='order_quantity' ? 'Quantity' : fieldName }{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Label
          className="m-0"
          style={{
            minWidth: "100px",
            color: "#226963",
            fontFamily: "Roboto",
            fontWeight: "600",
            fontSize: "18px",
          }}
        >
          Enter Value
        </Form.Label>
        <input
          style={{
            borderColor: "#226963",
            borderRadius: "5px",
            width: "150px",
            color: "black",
          }}
          type="string"
          placeholder={`Enter ${fieldName}`}
          value={val}
          onChange={(e) => setVal(e.target.value)}
          onKeyDown={(e) => {
            if (e.code == "Enter") {
              handleEditField();
            }
          }}
        />
      </Modal.Body>
      <Modal.Footer style={{ border: "none" }}>
        <Button variant="outline-secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button variant="info" style={{background:'rgb(34, 105, 99)', color:'white'}} onClick={handleEditField}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
